import React, { useEffect } from "react";
import {
    ContentContainer,
    SectionPage,
    Row,
    Col,
    Button,
    Heading,
    IconNotificationSuccess,
    pxToRem,
    tokens,
} from "@snsw-gel/react";

import styles from "./ChangeDetailsConfirmation.module.scss";
import { dataLayer } from "../../../services/gtm-dataLayer";

const ChangeDetailsConfirmationPage = () => {
    const confirmationResponse = sessionStorage.getItem("ConfirmationResponse");
    const cardText = sessionStorage.getItem("CardTypeText");

    useEffect(() => {
        const currentUrl = window.location.href;
        const pageName = window.location.href.split("/").pop();
        dataLayer(currentUrl, pageName);
    }, []);

    function getConfirmationHeader() {
        switch (confirmationResponse) {
            case "upgrade":
                return "Your NSW Senior Savers Card has been converted to a NSW Seniors Card";
            case "marketing":
                return `Your NSW ${cardText} marketing preferences have been updated`;
            case "replace":
                return `Thank you, we received your request to replace your NSW ${cardText}`;
            case "cancel":
                return `Your NSW ${cardText} has been cancelled`;
        }
    }

    function getConfirmationBody() {
        switch (confirmationResponse) {
            case "upgrade":
                return (
                    <p>
                        We'll send you a new physical card within 21 business days.
                        <br />
                        In the meantime, if you have downloaded your Service NSW Mobile app, you can access your digital{" "}
                        {cardText}.
                    </p>
                );
            case "marketing":
                return <p>You can update your marketing preferences at any time.</p>;
            case "replace":
                return (
                    <p>
                        We'll send you a new physical card within 21 business days.
                        <br />
                        In the meantime, if you have downloaded your Service NSW Mobile app, you can access your digital{" "}
                        {cardText}.
                    </p>
                );
            case "cancel":
                return (
                    <p>
                        You will no longer be able to use your NSW {cardText}. If you wish to rejoin, you can re-apply to receive
                        a new card.
                    </p>
                );
        }
    }

    return (
        <>
            <ContentContainer className={styles["content-container"]}>
                <Row className={styles["page-row"]}>
                    <Col span={12}>
                        <SectionPage className={styles["heading-section"]}>
                            <div className={styles["heading-title"]}>
                                <IconNotificationSuccess className={styles["success-icon"]} />
                                <Heading level={2}>{getConfirmationHeader()}</Heading>
                            </div>
                            {getConfirmationBody()}
                        </SectionPage>
                        <SectionPage>
                            <Button
                                className="dashboard-button"
                                style={{ marginTop: `${pxToRem(tokens.spacing.md)}` }}
                                href={
                                    confirmationResponse === "cancel"
                                        ? process.env.REACT_APP_DASHBOARD_URL
                                        : process.env.REACT_APP_SENIORS_DASHBOARD_URL
                                }
                            >
                                Back to dashboard
                            </Button>
                        </SectionPage>
                    </Col>
                </Row>
            </ContentContainer>
        </>
    );
};

export default ChangeDetailsConfirmationPage;
